// extracted by mini-css-extract-plugin
export var st0 = "bio-module--st0--3BUst";
export var svgElem1 = "bio-module--svgElem1--26_Da";
export var active = "bio-module--active--36Bag";
export var svgElem2 = "bio-module--svgElem2--1nwwJ";
export var svgElem3 = "bio-module--svgElem3--35QZP";
export var svgElem4 = "bio-module--svgElem4--mvge1";
export var svgElem5 = "bio-module--svgElem5--321jl";
export var svgElem6 = "bio-module--svgElem6--2-kKL";